import { render, staticRenderFns } from "./simulationExamPerson.vue?vue&type=template&id=16bfa449&scoped=true&"
import script from "./simulationExamPerson.vue?vue&type=script&lang=js&"
export * from "./simulationExamPerson.vue?vue&type=script&lang=js&"
import style0 from "./simulationExamPerson.vue?vue&type=style&index=0&id=16bfa449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfa449",
  null
  
)

export default component.exports